import React, { useEffect } from 'react'
import { useMapContext } from '../MapContext'
import {
  selectMapActiveBbox,
  selectMapBbox,
  selectMapSearchBbox,
  selectIsMapReady
} from '../../../store/map/map.selectors'
import { bboxArrayToBboxArrays } from '../conversion'
import { selectViewport } from '../../../store/address/address.selectors'
import { selectStepsCoordinates } from '../../itinerary/steps/steps.selectors'
import { getBboxFromLngLatPoints } from '../../utils/map'
import { useSelector } from 'react-redux'
import { isEmpty } from '../../../utils/lang'

const BboxDebugger = ({ bbox, id, fillColor = '#088' }) => {
  const { map } = useMapContext()
  const isMapReady = useSelector(selectIsMapReady)

  useEffect(() => {
    if (!map || !isMapReady || !bbox || !id) return

    const debugId = `${id}_debug_id`

    const [[x1, y1], [x2, y2]] = bbox
    const p1 = [Math.min(x1, x2), Math.min(y1, y2)]
    const p2 = [Math.max(x1, x2), Math.min(y1, y2)]
    const p3 = [Math.max(x1, x2), Math.max(y1, y2)]
    const p4 = [Math.min(x1, x2), Math.max(y1, y2)]

    const data = {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [[p1, p2, p3, p4, p1]]
      }
    }

    if (!isEmpty(map.getLayer(debugId))) {
      map.getSource(debugId).setData(data)
    } else {
      map.addLayer({
        id: debugId,
        type: 'fill',
        source: {
          type: 'geojson',
          data
        },
        paint: {
          'fill-color': fillColor,
          'fill-opacity': 0.3
        }
      })
    }

    return () => {
      if (map.getLayer(debugId)) {
        map.removeLayer(debugId)
        map.removeSource(debugId)
      }
    }
  }, [map, bbox?.toString(), id, isMapReady])

  return null
}

export const ViewportDebugger = () => {
  const bbox = bboxArrayToBboxArrays(useSelector(selectViewport))
  return <BboxDebugger bbox={bbox} id={'viewport'} fillColor={'#083'} />
}

export const MapBboxDebugger = () => {
  const bbox = useSelector(selectMapBbox)
  return <BboxDebugger bbox={bbox} id={'mapbbox'} fillColor={'#909'} />
}

export const ActiveBboxDebugger = () => {
  const bbox = useSelector(selectMapActiveBbox)
  return <BboxDebugger bbox={bbox} id={'mapactivebbox'} fillColor={'#d80'} />
}

export const SearchBboxDebugger = () => {
  const bbox = useSelector(selectMapSearchBbox)
  return <BboxDebugger bbox={bbox} id={'mapsearchbbox'} fillColor={'#07d'} />
}

export const StepsDebugger = () => {
  const { departure, arrival } = useSelector(selectStepsCoordinates)
  const bbox = departure && arrival ? getBboxFromLngLatPoints([departure, arrival]) : null
  return <BboxDebugger bbox={bbox} id={'steps'} fillColor={'#086'} />
}
